export default function isInDesktopView() {
  return window.frameElement !== null;
}
